import React from "react";
import PropTypes from "prop-types";
import { Button, Dropdown, Icon, Menu } from "antd";
import { IconLight } from "../icon_light";

const InputMultiButton = ({ options, selectedValues, onChange }) => {
  const handleMenuClick = item => {
    if (item && item.key) {
      selectedValues.push(item.key);
      // console.log("NEWWW", selectedValues, item.key, newSelectedValues);
      onChange(selectedValues);
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {options &&
        options.map(o => (
          <Menu.Item
            disabled={selectedValues.indexOf(o.value) >= 0}
            key={o.value}
          >
            {o.text ? o.text : o.value}
          </Menu.Item>
        ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <Button>
        <IconLight icon={"plus"} /> Element type <Icon type="down" />
      </Button>
    </Dropdown>
  );
};

InputMultiButton.propTypes = {
  options: PropTypes.array.isRequired,
  selectedValues: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default InputMultiButton;



// WEBPACK FOOTER //
// ./src/views/components/input_multi_button/InputMultiButton.jsx